import { client } from "../client";
import type { Paginated, PaginatedFilter } from "../types/axios.types";
import type { Material, MaterialLog } from "../types/material.types";

export const fetchMaterialsPaginated = async (
	page?: number,
	size?: number,
	search?: string,
	filters?: PaginatedFilter,
	sortBy?: string[],
) => {
	const params = new URLSearchParams();
	// Pagination
	params.append("page", page ? page.toString() : "1");
	params.append("size", size ? size.toString() : "50");
	// Search
	if (search) {
		params.append("search", search);
	}
	// Sort
	if (sortBy) {
		sortBy.forEach((key) => params.append("sort", key));
	}
	// Filters
	if (filters) {
		Object.keys(filters).forEach((key: string) => {
			// Blacklist some keys
			if (
				["page", "size", "search", "sort"].includes(key) ||
				filters[key] === ""
			) {
				return;
			}
			params.append(
				key,
				Array.isArray(filters[key]) ? filters[key].join(",") : filters[key],
			);
		});
	}
	// Query
	const response = await client.get<Paginated<Material[]>>(`materials/`, {
		params,
	});
	return response.data;
};

export const fetchMaterialLogsPaginated = async (
	id?: string | number,
	page?: number,
	size?: number,
) => {
	const params = new URLSearchParams();
	// Pagination
	params.append("page", page ? page.toString() : "1");
	params.append("size", size ? size.toString() : "50");
	// Query
	const response = await client.get<Paginated<MaterialLog[]>>(
		`materials/${id}/logs`,
		{
			params,
		},
	);
	return response.data;
};

export const fetchMaterialsByLabel = async (label: string) => {
	const response = await client.get<Material>(`materials/label/${label}/`);
	return response.data;
};
